export type Language = "it" | "en" | "es" | "pt-BR" | "fr";

const baseTranslations = {
  it: {
    // Header/Hero
    heroEyebrow: "Serie A Draft Simulator",
    heroTitle: "Serie A 38-0",
    heroSubtitle: "Crea la rosa perfetta aprendo pacchetti per ciascun ruolo. Bilancia intesa, rarità e cult hero per completare una stagione imbattuta!",
    draftProgress: "Avanzamento draft",
    languageSelectLabel: "Lingua",
    seoReadMore: "Leggi",
    draftXi: "Draft XI",
    simulated: "Simulato",
    shareCalloutLabel: "Sfida amici",
    shareCalloutTitle: "Sfida un amico dopo la simulazione",
    shareCalloutBody: "Completa la XI, copia il link sfida e confrontate il record.",

    // Layout
    moduloTattico: "Modulo Tattico",
    intesa: "Intesa",
    laTuaFormazione: "La tua formazione",
    risultati: "Risultati",
    daScegliere: "Da scegliere",
    scenarioRound: "Scenario draft · Suggestione del turno",
    giocatoriLegatiTema: "Giocatori di questo club (+16 intesa) o epoca (+10 intesa) aumentano l'intesa.",
    giocatoriDisponibili: "Giocatori disponibili",
    ricominciaDraft: "Ricomincia draft",
    rimescolaPack: "Nuovo scouting",
    rimescolaPackHint: "Nuovo giro scouting: ruoli e carte cambiano, ma la tua XI resta intatta.",
    packRuoliMisti: "Ruoli misti",
    ruoliNelPack: "Ruoli nel pack",
    slotTarget: "Slot",
    scegliSlotCarta: "Scegli lo slot per questa carta",
    preparazionePack: "Preparazione scouting",
    scoutingInCorso: "Scouting in corso: stiamo preparando le carte per il modulo.",
    scegliModulo: "Scegli modulo",
    modeSelectorLabel: "Modalità",
    storySelectorLabel: "Storie",
    difficultySelectorLabel: "Difficoltà",
    lineupPanelLabel: "Formazione",
    draftTabLabel: "Scelte",
    draftProgressStatus: (progress: number) => `Draft completato al ${progress}%`,
    roundLabel: (round: number) => `Round ${round}`,
    signCard: "INGAGGIA",
    draftedPlayersTitle: "Giocatori Ingaggiati",
    emptyRosterNote: "Nessun giocatore ancora ingaggiato",
    runIdentityTitle: "Identita della run",
    seasonMomentsTitle: "Momenti chiave",
    modeDifficultyEasy: "Facile",
    modeDifficultyMedium: "Media",
    modeDifficultyExpert: "Esperta",
    modeDifficultyHard: "Difficile",
    hiddenCardValueLabel: "Valore carta nascosto",
    hiddenStatValueLabel: "Statistica carta nascosta",
    hiddenSkillsetLabel: "Profilo scouting nascosto",
    hiddenMiniStatsLabel: "Dettagli scouting nascosti",
    hiddenReasonLabel: "Scouting coperto",
    hiddenLaneLabel: "Traccia nascosta",
    hiddenRarityLabel: "Valore nascosto",
    hiddenSourceLabel: "Fonte coperta",
    storyModernName: "Moderno",
    storyModernDesc: "Post-2010",
    storyNostalgiaName: "Nostalgia",
    storyNostalgiaDesc: "Anni 70-2000",
    storyProvinciaName: "Provincia",
    storyProvinciaDesc: "Outsider storiche",
    advancedChallengeLabel: "Sfide avanzate",
    advancedChallengeEyebrow: "Sfida",
    challengeClassicName: "Classica",
    challengeClassicDesc: "Draft libero, nessun tetto crediti.",
    challengeBudgetName: "Budget Mercato",
    challengeBudgetDesc: "Cap da 900 crediti: ogni carta costa, le stelle vanno pesate.",
    challengeTacticalName: "Tattico",
    challengeTacticalDesc: "Obiettivo legato al modulo: scegli carte che rispettano la traccia tattica.",
    budgetStatusLabel: "Budget Mercato",
    budgetCredits: "crediti",
    budgetSpentLabel: "Usati",
    cardCostLabel: "Costo",
    tacticalStatusLabel: "Sfida Tattica",
    tacticalOpenLabel: "Da completare",
    tacticalCompleteLabel: "Completata",
    tacticalFitLabel: "Fit tattico",
    tacticalResultLabel: "Tattica",
    tacticalResultComplete: "Centrata",
    roleMoveLabel: "Cambia ruolo",
    roleMoveAria: (name: string) => `Cambia ruolo per ${name}`,
    roleMovePanelTitle: "Cambia ruolo",
    roleMovePanelBody: "Scegli uno slot libero compatibile con i ruoli della carta.",
    currentRoleLabel: "Ruolo attuale",
    availableRolesLabel: "Ruoli disponibili",
    moveToSlot: (slot: string) => `Sposta in ${slot}`,
    noRoleMovesAvailable: "Nessuno slot compatibile libero.",
    roleMoveToast: (from: string, to: string) => `Giocatore spostato da ${from} a ${to}.`,
    closeRoleMovePanel: "Chiudi cambio ruolo",
    fixedRolesLabel: "Ruoli fissi",
    fixedRolesAria: (name: string) => `Ruoli fissi per ${name}`,
    seoEyebrow: "Scoperta gioco",
    seoTitle: "Draft Serie A in una schermata",
    seoBody: "Scegli una modalità, completa la tua XI e prova a chiudere 38 giornate senza sconfitte.",
    seoNostalgia: "Notti Nostalgia valorizza scudetti storici, numeri dieci e cult heroes dagli anni 70 ai 2000.",
    seoDraft: "Draft Moderno apre il pool post-2010 con stelle recenti e carte contemporanee oltre la nostalgia.",
    seoProvincia: "Provincia Magica dà spazio a outsider, provinciali leggendarie e carte amate dai tifosi del campionato italiano.",
    seoInstructionsLabel: "Istruzioni Serie A 38-0",
    seoStepModeTitle: "1. Scegli la modalità",
    seoStepModeBody: "Scegli tra Draft Moderno e Notti Nostalgia, poi regola la difficolta: Moderno parte Facile, Nostalgia parte Media.",
    seoStepDraftTitle: "2. Apri i pack ruolo per ruolo",
    seoStepDraftBody: "Ogni round propone carte per gli slot liberi: confronta ruolo, club, stagione, rarità e intesa prima di confermare.",
    seoStepSeasonTitle: "3. Simula le 38 giornate",
    seoStepSeasonBody: "Quando la XI è completa, il motore trasforma qualità, equilibrio e intesa in un record stagionale.",
    promptFallback: (club: string, era: string) => `${club}, ${era}: scegli una carta che sembri uscita da una domenica di 90° Minuto.`,

    // Rarity
    comune: "Comune",
    rara: "Rara",
    campione: "Campione",
    icona: "Icona",

    // Data Levels
    sourced: "Fonte dati",
    "curated-high": "Profilo storico",
    "curated-medium": "Profilo curato",
    derived: "Profilo derivato",
    profiloCuratoDefault: "Profilo curato",

    // fit labels
    fitPerfect: "Perfetto",
    fitClub: "Stesso club",
    fitEra: "Stessa epoca",
    fitWild: "Jolly",
    fitChemSuffix: "intesa",

    // Pack plan labels
    packProvincia: "Colpo di provincia",
    packIntesa: "Intesa",
    packAvvioOssatura: "Inizio blocco storico",
    packOssatura: "Compagno di stagione",
    packCreatore: "Creatore",
    packEquilibrio: "Equilibrio tattico",
    packSacrificio: "Scelta di sacrificio",
    packTalentoNascosto: "Talento nascosto",
    packStessaEpoca: "Stessa epoca",
    packJollyPazzo: "Jolly pazzo",
    packExact: "Prompt perfetto",
    packTitolareFisso: "Titolare fisso",
    packImpattoGol: "Impatto gol",
    packRotazione: "Rotazione",
    packStoriaClub: "Storia del club",
    packIntesaBandiera: "Intesa bandiera",
    packIdoloAssoluto: "Idolo assoluto",
    packEpocaGiusta: "Epoca giusta",
    packImpatto: "Impatto",
    packVersioneCult: "Versione cult",
    packIcona: "Icona",
    packCultHero: "Cult hero",
    packFuoriclasse: "Fuoriclasse",
    packSorpresa: "Sorpresa",
    packJolly: "Jolly",
    packLeggendaFuori: "Leggenda fuori piazza",

    // Results card
    risultatoStagione: "Risultato stagione",
    punti: "punti",
    valutazione: "Valutazione",
    attacco: "Attacco",
    mvp: "MVP",
    cronacaStagione: "Cronaca della Stagione",
    copyChallengeLink: "Copia sfida",
    challengeLinkCopied: "Sfida copiata!",
    sharedChallengeLabel: "Sfida amici",
    sharedActiveTitle: "Sfida amici attiva",
    sharedActiveTargetTitle: "Squadra da battere",
    sharedActiveTargetSummary: (points: number, rating: number) => `${points} punti · Valutazione ${rating}`,
    sharedActiveProgress: (picked: number, total: number, progress: number) => `${picked}/${total} scelte · ${progress}% della XI`,
    sharedComparisonTitle: "Sfida contro una squadra condivisa",
    yourRunLabel: "La tua run",
    sharedRunLabel: "Squadra da battere",
    sharedComparisonWon: "Vittoria contro la squadra condivisa",
    sharedComparisonLost: "Sconfitta contro la squadra condivisa",
    sharedComparisonDraw: "Pareggio contro la squadra condivisa",
    sharedComparisonDetail: (pointsDiff: number, ratingDiff: number) => `${pointsDiff >= 0 ? "+" : ""}${pointsDiff} punti, ${ratingDiff >= 0 ? "+" : ""}${ratingDiff.toFixed(1)} valutazione.`,
    sharedComparisonTieDetail: "Stessi punti, valutazione e intesa: sfida in perfetto equilibrio.",
    recordSimulato: "Record simulato",
    dettaglioSimulazione: "Dettaglio simulazione",
    cronacaLabel: "Cronaca",
    easterEggNostalgici: "Easter egg nostalgici",
    // Player stats mini info
    golStats: "gol",
    assistStats: "assist",
    presStats: "pres.",
    ruoloChiave: "Ruolo chiave",
    gameplayRatingLabel: "Rating gameplay",

    // Mode choice
    scegliClubFocus: "Scegli il club focus",
    clubFocusKicker: "Club focus",

    // Data notice
    origineDati: "Origine dei Dati",
    dataNotice: "Due storie di draft: Moderno post-2010 e Nostalgia storica, ciascuna con difficolta dedicate. La slice 2022-23 usa presenze, titolarita e gol da StatBunker; ruoli e microcopy restano metadata di gameplay.",
    cookieBannerLabel: "Preferenze cookie",
    cookieBannerTitle: "Cookie analytics",
    cookieBannerBody: "Usiamo PostHog per capire quali modalità funzionano meglio e migliorare il draft. Puoi rifiutare in qualsiasi momento e continuare a giocare.",
    cookieAccept: "Accetta",
    cookieDecline: "Rifiuta",
    feedbackOpen: "Feedback",
    feedbackEyebrow: "Suggerimento rapido",
    feedbackTitle: "Aiutaci a migliorare",
    feedbackClose: "Chiudi feedback",
    feedbackCategoryLabel: "Tipo",
    feedbackCategoryGameplay: "Gameplay",
    feedbackCategoryData: "Giocatore o dato",
    feedbackCategoryBug: "Bug",
    feedbackCategoryOther: "Altro",
    feedbackMessageLabel: "Messaggio",
    feedbackMessagePlaceholder: "Cosa non ha funzionato, chi manca, o cosa cambieresti?",
    feedbackEmailLabel: "Email opzionale",
    feedbackEmailPlaceholder: "se vuoi una risposta",
    feedbackCancel: "Annulla",
    feedbackSubmit: "Invia",
    feedbackSending: "Invio...",
    feedbackSuccess: "Grazie, feedback ricevuto.",
    feedbackError: "Non siamo riusciti a inviare. Riprova tra poco.",
    appSurveyEyebrow: "Sondaggio app",
    appSurveyTitle: "Vorresti Serie A 38-0 come app?",
    appSurveyBody: "Vota la piattaforma che useresti. Se vuoi aggiornamenti, lascia anche l'email: e facoltativa.",
    appSurveyPlatformLabel: "Piattaforma app",
    appSurveyPlatformIos: "iOS",
    appSurveyPlatformAndroid: "Android",
    appSurveyPlatformBoth: "Entrambe",
    appSurveyEmailLabel: "Email opzionale",
    appSurveyEmailPlaceholder: "per aggiornamenti sull'app",
    appSurveySubmit: "Vota",
    appSurveySending: "Invio...",
    appSurveySentButton: "Voto inviato",
    appSurveySuccess: "Grazie, voto registrato.",
    appSurveyError: "Non siamo riusciti a registrare il voto. Riprova tra poco.",
    appSurveyPrivacy: "Niente account: solo un voto di interesse e, se la lasci, la tua email.",

    // Positions (Tactical pitch)
    gk: "POR",
    lb: "TS",
    cb1: "DC",
    cb2: "DC",
    rb: "TD",
    cm1: "Mezzala sx",
    regista: "Regista",
    cm2: "Mezzala dx",
    trequartista: "Trequartista",
    lm: "Esterno sx",
    rm: "Esterno dx",
    lw: "Ala sinistra",
    st: "Centravanti",
    st1: "Punta sx",
    st2: "Punta dx",
    rw: "Ala destra",

    // Position abbreviations for cards
    gk_abbr: "POR",
    lb_abbr: "TS",
    cb1_abbr: "DC",
    cb2_abbr: "DC",
    rb_abbr: "TD",
    cm1_abbr: "CC",
    regista_abbr: "REG",
    cm2_abbr: "CC",
    trequartista_abbr: "TRQ",
    lm_abbr: "ES",
    rm_abbr: "ED",
    lw_abbr: "AS",
    rw_abbr: "AD",
    st_abbr: "ATT",
    st1_abbr: "PUN",
    st2_abbr: "PUN",

    // Modes details
    modeDraftName: "Draft Moderno",
    modeDraftShort: "Draft",
    modeDraftDesc: "Draft moderno facile: post-2010, ruoli mobili e spazio per sperimentare senza vincoli duri.",
    modeDraftTone: "Stelle recenti, scouting moderno e incroci liberi senza vincoli di club.",

    modeDraftHardName: "Draft Moderno Difficile",
    modeDraftHardShort: "Difficile",
    modeDraftHardDesc: "Post-2010 con ruoli fissi, almeno quattro club e un tetto alle scelte headline.",
    modeDraftHardTone: "La Serie A recente in versione expert: equilibrio, lavoro sporco e scelte meno automatiche.",

    modeNostalgiaName: "Notti Nostalgia",
    modeNostalgiaShort: "Nostalgia",
    modeNostalgiaDesc: "Anni 70, 80, 90 e pochissimi cameo 2000: Toro scudetto, Zemanlandia, Empoli di Spalletti, Di Vaio a Salerno, Recoba a Venezia e domeniche da VHS.",
    modeNostalgiaTone: "Maglie larghe, numeri dieci, telecronache infinite e sigle viste su un televisore a tubo catodico.",

    modeNostalgiaHardName: "Notti Nostalgia Difficile",
    modeNostalgiaHardShort: "Nostalgia",
    modeNostalgiaHardDesc: "Archivio storico con ruoli fissi, piu stagioni obbligate e quasi nessuna scorciatoia anni 2000.",
    modeNostalgiaHardTone: "Amarcord in versione dura: meno cameo comodi, piu epoche da incastrare.",

    modeProvinciaMediumName: "Provincia Magica Media",
    modeProvinciaMediumShort: "Provincia",
    modeProvinciaMediumDesc: "Provincia storica piu permissiva: outsider, cult hero e ruoli mobili per imparare il pool.",
    modeProvinciaMediumTone: "La provincia resta romantica, ma concede piu margine alla prima run.",

    modeProvinciaName: "Provincia Magica",
    modeProvinciaShort: "Provincia",
    modeProvinciaDesc: "Cagliari, Verona, Venezia, Reggina, Lecce, Salernitana, Empoli, Foggia, Perugia, Vicenza, Piacenza, Brescia, Bari, Chievo, Parma, Samp, Palermo, Fiorentina e Bologna storiche.",
    modeProvinciaTone: "Quando la provincia mette paura al vertice.",

    // Eras labels
    anni70: "Anni 70",
    anni80: "Anni 80",
    anni90: "Anni 90",
    anni2000: "Anni 2000",
    anni2010: "Anni 2010",
    moderna: "Era moderna",

    // Easter eggs
    eggviallimancini: "Gemelli del gol",
    eggkvaraosimhen: "Kvaradona + maschera",
    egglookmanosimhen: "Naija Serie A",
    eggleaokaka: "Highlight generation",
    eggbuffonthuram: "Parma coppa nostalgia",
    eggadrianokaka: "Brasile in Serie A",
    eggjuliomaicon: "Triplete brasileiro",
    eggtotticafu: "Roma scudetto",
    eggmuseo: "Museo del campionato",

    // Chronicle template
    chronicleTopPlayer: (name: string, rating: number) => `${name} è stato il volto indiscusso della stagione, trascinando la squadra con rating globale ${rating}.`,
    chronicleClubBlock: (club: string, count: number) => `Il blocco del club ${club} è stato fondamentale, fornendo ben ${count} pilastri titolari.`,
    chroniclePhilosophy: (formattedEra: string) => `La filosofia calcistica ${formattedEra} ha dominato l'identità tattica del tuo undici.`,
    chronicleCountryColony: (country: string, count: number) => `Il nucleo di giocatori provenienti da: ${country} (ben ${count} elementi) ha creato un'intesa speciale nello spogliatoio.`,
    chronicleMaradona: "A Napoli basta pronunciare il nome di Diego per trasformare ogni domenica in pura poesia calcistica.",
    chronicleRonaldo: "Il Fenomeno Ronaldo ha spaccato le partite più chiuse con accelerazioni devastanti, un autentico cheat code d'altri tempi.",
    chronicleAdriano: "La potenza fisica devastante dell'Imperatore Adriano ha piegato le difese avversarie nel finale di stagione.",
    // Formatted eras for chronicle
    formatted_anni70: "degli anni 70",
    formatted_anni80: "degli anni 80",
    formatted_anni90: "degli anni 90",
    formatted_anni2000: "degli anni 2000",
    formatted_anni2010: "degli anni 2010",
    formatted_moderna: "dell'era moderna",

    // Simulation outcomes
    simOut38winsTitle: "38-0: Epopea Leggendaria!",
    simOut38winsDetail: "Hai assemblato un'armata invincibile. Tattica sublime, intesa d'altri tempi e fuoriclasse assoluti: la storia della Serie A ti appartiene!",
    
    simOutNoLossesTitle: "Gli Invincibili!",
    simOutNoLossesDetail: "Nessuna sconfitta in 38 giornate. La Gazzetta dello Sport celebra in prima pagina una difesa d'acciaio e un'intesa degna del grande Milan di Capello.",
    
    simOutScudettoTitle: "Campioni d'Italia!",
    simOutScudettoDetail: "Scudetto strameritato. Una marcia trionfale condita da sprazzi di classe pura e una continuità impressionante per tutto il campionato.",
    
    simOutChampionsTitle: "Zona Champions",
    simOutChampionsDetail: "Grande qualità complessiva, ma i troppi pareggi e qualche blackout difensivo vi costano la lotta scudetto. Ci si consola con l'Europa che conta."
  },
  en: {
    // Header/Hero
    heroEyebrow: "Serie A Draft Simulator",
    heroTitle: "Serie A 38-0",
    heroSubtitle: "Build the perfect squad by opening card packs for each role. Balance chemistry, rarity, and cult heroes to complete an unbeaten season!",
    draftProgress: "Draft progress",
    languageSelectLabel: "Language",
    seoReadMore: "Read",
    draftXi: "Draft XI",
    simulated: "Simulated",
    shareCalloutLabel: "Friend challenge",
    shareCalloutTitle: "Challenge a friend after the simulation",
    shareCalloutBody: "Complete your XI, copy the challenge link, and compare records.",

    // Layout
    moduloTattico: "Tactical Layout",
    intesa: "Chemistry",
    laTuaFormazione: "Your Lineup",
    risultati: "Results",
    daScegliere: "To choose",
    scenarioRound: "Amarcord Card · Round Focus",
    giocatoriLegatiTema: "Players from this club (+16 chem) or era (+10 chem) boost chemistry.",
    giocatoriDisponibili: "Available Players",
    ricominciaDraft: "Reset Draft",
    rimescolaPack: "Shuffle pack",
    rimescolaPackHint: "Fresh scouting round: roles and cards change, but your XI stays intact.",
    packRuoliMisti: "Mixed roles",
    ruoliNelPack: "Pack roles",
    slotTarget: "Slot",
    scegliSlotCarta: "Choose this card's slot",
    preparazionePack: "Preparing pack",
    scoutingInCorso: "Scouting in progress: preparing cards for the formation.",
    scegliModulo: "Choose formation",
    modeSelectorLabel: "Mode",
    storySelectorLabel: "Stories",
    difficultySelectorLabel: "Difficulty",
    lineupPanelLabel: "Lineup",
    draftTabLabel: "Draft",
    draftProgressStatus: (progress: number) => `Draft completed at ${progress}%`,
    roundLabel: (round: number) => `Round ${round}`,
    signCard: "SIGN",
    draftedPlayersTitle: "Drafted Players",
    emptyRosterNote: "No players drafted yet",
    runIdentityTitle: "Run identity",
    seasonMomentsTitle: "Key moments",
    modeDifficultyEasy: "Easy",
    modeDifficultyMedium: "Medium",
    modeDifficultyExpert: "Expert",
    modeDifficultyHard: "Hard",
    hiddenCardValueLabel: "Hidden card value",
    hiddenStatValueLabel: "Hidden card stat",
    hiddenSkillsetLabel: "Hidden scouting profile",
    hiddenMiniStatsLabel: "Hidden scouting details",
    hiddenReasonLabel: "Hidden scouting",
    hiddenLaneLabel: "Hidden lane",
    hiddenRarityLabel: "Hidden value",
    hiddenSourceLabel: "Hidden source",
    storyModernName: "Modern",
    storyModernDesc: "Post-2010",
    storyNostalgiaName: "Nostalgia",
    storyNostalgiaDesc: "70s-2000s",
    storyProvinciaName: "Provincia",
    storyProvinciaDesc: "Historic outsiders",
    advancedChallengeLabel: "Advanced challenges",
    advancedChallengeEyebrow: "Challenge",
    challengeClassicName: "Classic",
    challengeClassicDesc: "Free draft, no credit cap.",
    challengeBudgetName: "Market Budget",
    challengeBudgetDesc: "900-credit cap: every card has a cost, and stars need tradeoffs.",
    challengeTacticalName: "Tactical",
    challengeTacticalDesc: "Formation-linked objective: draft cards that fit the tactical brief.",
    budgetStatusLabel: "Market Budget",
    budgetCredits: "credits",
    budgetSpentLabel: "Used",
    cardCostLabel: "Cost",
    tacticalStatusLabel: "Tactical Challenge",
    tacticalOpenLabel: "Open",
    tacticalCompleteLabel: "Complete",
    tacticalFitLabel: "Tactical fit",
    tacticalResultLabel: "Tactical",
    tacticalResultComplete: "Hit",
    roleMoveLabel: "Change role",
    roleMoveAria: (name: string) => `Change role for ${name}`,
    roleMovePanelTitle: "Change role",
    roleMovePanelBody: "Choose a free slot compatible with this card's roles.",
    currentRoleLabel: "Current role",
    availableRolesLabel: "Available roles",
    moveToSlot: (slot: string) => `Move to ${slot}`,
    noRoleMovesAvailable: "No compatible free slot.",
    roleMoveToast: (from: string, to: string) => `Player moved from ${from} to ${to}.`,
    closeRoleMovePanel: "Close role change",
    fixedRolesLabel: "Fixed roles",
    fixedRolesAria: (name: string) => `Fixed roles for ${name}`,
    seoEyebrow: "Game discovery",
    seoTitle: "Serie A draft in one screen",
    seoBody: "Pick a mode, complete your XI, and see whether it can finish 38 matches unbeaten.",
    seoNostalgia: "Nostalgia Nights highlights historic title teams, number tens, and cult heroes from the 1970s through the 2000s.",
    seoDraft: "Modern Draft opens the post-2010 pool with recent stars and contemporary cards beyond nostalgia.",
    seoProvincia: "Provincial Magic celebrates outsiders, legendary provincial clubs, and cards loved by Italian football fans.",
    seoInstructionsLabel: "Serie A 38-0 instructions",
    seoStepModeTitle: "1. Pick a mode",
    seoStepModeBody: "Pick Modern Draft or Nostalgia Nights, then set the difficulty. Modern starts on Easy; Nostalgia starts on Medium.",
    seoStepDraftTitle: "2. Open role-by-role packs",
    seoStepDraftBody: "Each round offers cards for open lineup slots: compare role, club, season, rarity, and chemistry before locking one in.",
    seoStepSeasonTitle: "3. Simulate 38 matchdays",
    seoStepSeasonBody: "When the XI is complete, the engine turns quality, balance, and chemistry into a season record.",
    promptFallback: (club: string, era: string) => `${club}, ${era}: pick a card that feels lifted from a classic Serie A Sunday.`,

    // Rarity
    comune: "Common",
    rara: "Rare",
    campione: "Champion",
    icona: "Icon",

    // Data Levels
    sourced: "Sourced stats",
    "curated-high": "Historical profile",
    "curated-medium": "Curated profile",
    derived: "Derived profile",
    profiloCuratoDefault: "Curated profile",

    // fit labels
    fitPerfect: "Perfect",
    fitClub: "Same club",
    fitEra: "Same era",
    fitWild: "Wildcard",
    fitChemSuffix: "chemistry",

    // Pack plan labels
    packProvincia: "Provincial Gem",
    packIntesa: "Chemistry",
    packAvvioOssatura: "Spine Starter",
    packOssatura: "Squad Spine",
    packCreatore: "Creator",
    packEquilibrio: "Tactical Balance",
    packSacrificio: "Sacrifice Pick",
    packTalentoNascosto: "Hidden Talent",
    packStessaEpoca: "Same Era",
    packJollyPazzo: "Wildcard",
    packExact: "Perfect Match",
    packTitolareFisso: "Consistent Starter",
    packImpattoGol: "Goal Scorer",
    packRotazione: "Rotation Option",
    packStoriaClub: "Club History",
    packIntesaBandiera: "Iconic Chemistry",
    packIdoloAssoluto: "Absolute Icon",
    packEpocaGiusta: "Right Era",
    packImpatto: "High Impact",
    packVersioneCult: "Cult Version",
    packIcona: "Icon",
    packCultHero: "Cult Hero",
    packFuoriclasse: "World Class",
    packSorpresa: "Surprise",
    packJolly: "Wildcard",
    packLeggendaFuori: "Provincial Legend",

    // Results card
    risultatoStagione: "Season Results",
    punti: "points",
    valutazione: "Rating",
    attacco: "Attack",
    mvp: "MVP",
    cronacaStagione: "Season Chronicle",
    copyChallengeLink: "Copy challenge",
    challengeLinkCopied: "Challenge copied!",
    sharedChallengeLabel: "Friend challenge",
    sharedActiveTitle: "Friend challenge active",
    sharedActiveTargetTitle: "Team to beat",
    sharedActiveTargetSummary: (points: number, rating: number) => `${points} points · Rating ${rating}`,
    sharedActiveProgress: (picked: number, total: number, progress: number) => `${picked}/${total} picks · ${progress}% of the XI`,
    sharedComparisonTitle: "Challenge against a shared team",
    yourRunLabel: "Your run",
    sharedRunLabel: "Team to beat",
    sharedComparisonWon: "Win against the shared team",
    sharedComparisonLost: "Loss against the shared team",
    sharedComparisonDraw: "Draw against the shared team",
    sharedComparisonDetail: (pointsDiff: number, ratingDiff: number) => `${pointsDiff >= 0 ? "+" : ""}${pointsDiff} points, ${ratingDiff >= 0 ? "+" : ""}${ratingDiff.toFixed(1)} rating.`,
    sharedComparisonTieDetail: "Same points, rating and chemistry: the challenge is level.",
    recordSimulato: "Simulated record",
    dettaglioSimulazione: "Simulation details",
    cronacaLabel: "Chronicle",
    easterEggNostalgici: "Nostalgic Easter Eggs",

    // Player stats mini info
    golStats: "goals",
    assistStats: "assists",
    presStats: "apps.",
    ruoloChiave: "Key role",
    gameplayRatingLabel: "Gameplay rating",

    // Mode choice
    scegliClubFocus: "Select focus club",
    clubFocusKicker: "Focus club",

    // Data notice
    origineDati: "Data Provenance",
    dataNotice: "Two draft stories: post-2010 Modern and historic Nostalgia, each with dedicated difficulty choices. The 2022-23 slice uses StatBunker appearances, starts, and goals; roles and microcopy remain gameplay metadata.",
    cookieBannerLabel: "Cookie preferences",
    cookieBannerTitle: "Analytics cookies",
    cookieBannerBody: "We use PostHog to understand which modes work best and improve the draft. You can decline at any time and keep playing.",
    cookieAccept: "Accept",
    cookieDecline: "Decline",
    feedbackOpen: "Feedback",
    feedbackEyebrow: "Quick note",
    feedbackTitle: "Help improve the game",
    feedbackClose: "Close feedback",
    feedbackCategoryLabel: "Type",
    feedbackCategoryGameplay: "Gameplay",
    feedbackCategoryData: "Player or data",
    feedbackCategoryBug: "Bug",
    feedbackCategoryOther: "Other",
    feedbackMessageLabel: "Message",
    feedbackMessagePlaceholder: "What felt wrong, who is missing, or what would you change?",
    feedbackEmailLabel: "Optional email",
    feedbackEmailPlaceholder: "if you want a reply",
    feedbackCancel: "Cancel",
    feedbackSubmit: "Send",
    feedbackSending: "Sending...",
    feedbackSuccess: "Thanks, feedback received.",
    feedbackError: "We could not send it. Try again shortly.",
    appSurveyEyebrow: "App survey",
    appSurveyTitle: "Would you want Serie A 38-0 as an app?",
    appSurveyBody: "Vote for the platform you would use. Leave an email only if you want updates.",
    appSurveyPlatformLabel: "App platform",
    appSurveyPlatformIos: "iOS",
    appSurveyPlatformAndroid: "Android",
    appSurveyPlatformBoth: "Both",
    appSurveyEmailLabel: "Optional email",
    appSurveyEmailPlaceholder: "for app updates",
    appSurveySubmit: "Vote",
    appSurveySending: "Sending...",
    appSurveySentButton: "Vote sent",
    appSurveySuccess: "Thanks, vote recorded.",
    appSurveyError: "We could not record the vote. Try again shortly.",
    appSurveyPrivacy: "No account: just an interest vote and, if you add it, your email.",

    // Positions (Tactical pitch)
    gk: "GK",
    lb: "LB",
    cb1: "CB",
    cb2: "CB",
    rb: "RB",
    cm1: "LCM",
    regista: "Regista",
    cm2: "RCM",
    trequartista: "Playmaker",
    lm: "LM",
    rm: "RM",
    lw: "LW",
    st: "ST",
    st1: "LST",
    st2: "RST",
    rw: "RW",

    // Position abbreviations for cards
    gk_abbr: "GK",
    lb_abbr: "LB",
    cb1_abbr: "CB",
    cb2_abbr: "CB",
    rb_abbr: "RB",
    cm1_abbr: "LCM",
    regista_abbr: "REG",
    cm2_abbr: "RCM",
    trequartista_abbr: "CAM",
    lm_abbr: "LM",
    rm_abbr: "RM",
    lw_abbr: "LW",
    rw_abbr: "RW",
    st_abbr: "ST",
    st1_abbr: "LST",
    st2_abbr: "RST",

    // Modes details
    modeDraftName: "Modern Draft",
    modeDraftShort: "Draft",
    modeDraftDesc: "Easy modern draft: post-2010 players, movable roles, and room to experiment.",
    modeDraftTone: "Recent stars, modern scouting, and open combinations with no favorite-club lock.",

    modeDraftHardName: "Modern Draft Hard",
    modeDraftHardShort: "Hard",
    modeDraftHardDesc: "Post-2010 with fixed roles, at least four clubs, and a cap on headline picks.",
    modeDraftHardTone: "Recent Serie A in expert form: balance, work rate, and fewer automatic picks.",

    modeNostalgiaName: "Nostalgia Nights",
    modeNostalgiaShort: "Nostalgia",
    modeNostalgiaDesc: "70s, 80s, 90s, and tiny 2000s cameos: title-winning Torino, Zemanlandia, Spalletti's Empoli, Di Vaio at Salernitana, Recoba at Venezia, and VHS Sundays.",
    modeNostalgiaTone: "Baggy jerseys, classic number tens, endless commentating, and old TV title music.",

    modeNostalgiaHardName: "Nostalgia Nights Hard",
    modeNostalgiaHardShort: "Nostalgia",
    modeNostalgiaHardDesc: "The same historic archive with fixed roles, more required seasons, and almost no easy 2000s shortcuts.",
    modeNostalgiaHardTone: "Hard-mode memory: fewer comfortable cameos, more eras to stitch together.",

    modeProvinciaMediumName: "Provincia Magic Medium",
    modeProvinciaMediumShort: "Provincia",
    modeProvinciaMediumDesc: "A more forgiving historic provincia run: outsiders, cult heroes, and movable roles while you learn the pool.",
    modeProvinciaMediumTone: "The provincial romance stays, with more room on the first run.",

    modeProvinciaName: "Provincia Magic",
    modeProvinciaShort: "Provincia",
    modeProvinciaDesc: "Historic Cagliari, Verona, Venezia, Reggina, Lecce, Salernitana, Empoli, Foggia, Perugia, Vicenza, Piacenza, Brescia, Bari, Chievo, Parma, Sampdoria, Palermo, Fiorentina, and Bologna.",
    modeProvinciaTone: "When the provincials put fear into the giants.",

    // Eras labels
    anni70: "70s",
    anni80: "80s",
    anni90: "90s",
    anni2000: "2000s",
    anni2010: "2010s",
    moderna: "Modern era",

    // Easter eggs
    eggviallimancini: "Goal Twins",
    eggkvaraosimhen: "Kvaradona + Mask",
    egglookmanosimhen: "Naija Serie A",
    eggleaokaka: "Highlight Generation",
    eggbuffonthuram: "Parma Nostalgia Cup",
    eggadrianokaka: "Brazil in Serie A",
    eggjuliomaicon: "Brazilian Treble",
    eggtotticafu: "Roma Scudetto",
    eggmuseo: "League Museum",

    // Chronicle template
    chronicleTopPlayer: (name: string, rating: number) => `${name} was the undisputed face of the season, carrying the team with an overall rating of ${rating}.`,
    chronicleClubBlock: (club: string, count: number) => `The ${club} club block was fundamental, providing no fewer than ${count} starting pillars.`,
    chroniclePhilosophy: (formattedEra: string) => `The tactical philosophy ${formattedEra} dominated your XI's identity.`,
    chronicleCountryColony: (country: string, count: number) => `The core of players from ${country} (${count} elements) created a special chemistry in the dressing room.`,
    chronicleMaradona: "In Naples, simply mentioning Diego's name is enough to turn any Sunday into pure football poetry.",
    chronicleRonaldo: "Il Fenomeno Ronaldo broke open the tightest matches with devastating accelerations, an authentic vintage cheat code.",
    chronicleAdriano: "The devastating physical power of L'Imperatore Adriano bent opposing defenses late in the season.",
    // Formatted eras for chronicle
    formatted_anni70: "of the 70s",
    formatted_anni80: "of the 80s",
    formatted_anni90: "of the 90s",
    formatted_anni2000: "of the 2000s",
    formatted_anni2010: "of the 2010s",
    formatted_moderna: "of the modern era",

    // Simulation outcomes
    simOut38winsTitle: "38-0: Legendary Epoch!",
    simOut38winsDetail: "You have assembled an invincible army. Sublime tactics, vintage chemistry, and absolute class: the history of Serie A belongs to you!",
    
    simOutNoLossesTitle: "The Invincibles!",
    simOutNoLossesDetail: "Zero defeats in 38 matchdays. La Gazzetta dello Sport celebrates on the front page a steel-like defense and a chemistry worthy of Capello's great Milan.",
    
    simOutScudettoTitle: "Champions of Italy!",
    simOutScudettoDetail: "A well-deserved Scudetto. A triumphal march topped with flashes of pure class and impressive consistency throughout the league season.",
    
    simOutChampionsTitle: "Champions League Qualification",
    simOutChampionsDetail: "Great overall quality, but too many draws and occasional defensive lapses cost you the title race. Consolation comes with a spot in top-tier European football."
  }
};

export const translations = {
  ...baseTranslations,
  es: {
    ...baseTranslations.en,
    heroEyebrow: "Simulador de draft de Serie A",
    heroTitle: "Serie A 38-0",
    heroSubtitle: "Construye la plantilla perfecta abriendo sobres para cada rol. Equilibra química, rareza y héroes de culto para completar una temporada invicta.",
    draftProgress: "Progreso del draft",
    languageSelectLabel: "Idioma",
    seoReadMore: "Leer",
    draftXi: "XI del draft",
    simulated: "Simulado",
    shareCalloutLabel: "Reto para amigos",
    shareCalloutTitle: "Reta a un amigo tras la simulación",
    shareCalloutBody: "Completa tu XI, copia el enlace del reto y comparad récords.",
    moduloTattico: "Disposición táctica",
    intesa: "Química",
    laTuaFormazione: "Tu alineación",
    risultati: "Resultados",
    daScegliere: "Por elegir",
    scenarioRound: "Escenario de draft · Inspiración de la ronda",
    giocatoriLegatiTema: "Los jugadores de este club (+16 química) o época (+10 química) aumentan la química.",
    giocatoriDisponibili: "Jugadores disponibles",
    ricominciaDraft: "Reiniciar draft",
    rimescolaPack: "Nuevo scouting",
    rimescolaPackHint: "Nueva ronda de scouting: cambian roles y cartas, pero tu XI queda intacto.",
    packRuoliMisti: "Roles mixtos",
    ruoliNelPack: "Roles del sobre",
    slotTarget: "Slot",
    scegliSlotCarta: "Elige el slot de esta carta",
    preparazionePack: "Preparando scouting",
    scoutingInCorso: "Scouting en curso: estamos preparando las cartas para la formación.",
    scegliModulo: "Elegir formación",
    modeSelectorLabel: "Modos",
    storySelectorLabel: "Historias",
    difficultySelectorLabel: "Dificultad",
    lineupPanelLabel: "Alineación",
    draftTabLabel: "Elecciones",
    draftProgressStatus: (progress: number) => `Draft completado al ${progress}%`,
    roundLabel: (round: number) => `Ronda ${round}`,
    signCard: "FICHAR",
    draftedPlayersTitle: "Jugadores fichados",
    emptyRosterNote: "Aún no hay jugadores fichados",
    runIdentityTitle: "Identidad de la run",
    seasonMomentsTitle: "Momentos clave",
    modeDifficultyEasy: "Fácil",
    modeDifficultyMedium: "Media",
    modeDifficultyExpert: "Experta",
    modeDifficultyHard: "Difícil",
    hiddenCardValueLabel: "Valor de carta oculto",
    hiddenStatValueLabel: "Estadística de carta oculta",
    hiddenSkillsetLabel: "Perfil de scouting oculto",
    hiddenMiniStatsLabel: "Detalles de scouting ocultos",
    hiddenReasonLabel: "Scouting oculto",
    hiddenLaneLabel: "Ruta oculta",
    hiddenRarityLabel: "Valor oculto",
    hiddenSourceLabel: "Fuente oculta",
    storyModernName: "Moderno",
    storyModernDesc: "Post-2010",
    storyNostalgiaName: "Nostalgia",
    storyNostalgiaDesc: "Años 70-2000",
    storyProvinciaName: "Provincia",
    storyProvinciaDesc: "Outsiders históricos",
    advancedChallengeLabel: "Desafíos avanzados",
    advancedChallengeEyebrow: "Desafío",
    challengeClassicName: "Clásica",
    challengeClassicDesc: "Draft libre, sin límite de créditos.",
    challengeBudgetName: "Presupuesto Mercato",
    challengeBudgetDesc: "Límite de 900 créditos: cada carta cuesta y las estrellas exigen renuncias.",
    challengeTacticalName: "Táctico",
    challengeTacticalDesc: "Objetivo ligado al módulo: elige cartas que respeten el plan táctico.",
    budgetStatusLabel: "Presupuesto Mercato",
    budgetCredits: "créditos",
    budgetSpentLabel: "Usados",
    cardCostLabel: "Coste",
    tacticalStatusLabel: "Desafío táctico",
    tacticalOpenLabel: "Por completar",
    tacticalCompleteLabel: "Completado",
    tacticalFitLabel: "Encaje táctico",
    tacticalResultLabel: "Táctica",
    tacticalResultComplete: "Cumplida",
    roleMoveLabel: "Cambiar rol",
    roleMoveAria: (name: string) => `Cambiar rol de ${name}`,
    roleMovePanelTitle: "Cambiar rol",
    roleMovePanelBody: "Elige un hueco libre compatible con los roles de esta carta.",
    currentRoleLabel: "Rol actual",
    availableRolesLabel: "Roles disponibles",
    moveToSlot: (slot: string) => `Mover a ${slot}`,
    noRoleMovesAvailable: "No hay hueco compatible libre.",
    roleMoveToast: (from: string, to: string) => `Jugador movido de ${from} a ${to}.`,
    closeRoleMovePanel: "Cerrar cambio de rol",
    fixedRolesLabel: "Roles fijos",
    fixedRolesAria: (name: string) => `Roles fijos para ${name}`,
    seoEyebrow: "Descubrir el juego",
    seoTitle: "Draft de Serie A, química y simulación en una sola pantalla jugable",
    seoBody: "Serie A 38-0 es un juego de navegador estático e inmediato: elige modo, abre sobres por rol, completa tu XI y comprueba si puede terminar 38 partidos invicto.",
    seoNostalgia: "Notti Nostalgia destaca campeones históricos, números diez y héroes de culto de los años 70 a los 2000.",
    seoDraft: "Draft Moderno abre el grupo post-2010 con estrellas recientes y cartas contemporáneas más allá de la nostalgia.",
    seoProvincia: "Provincia Magica celebra outsiders, clubes provinciales legendarios y cartas queridas por los fans del calcio.",
    seoInstructionsLabel: "Instrucciones de Serie A 38-0",
    seoStepModeTitle: "1. Elige un modo",
    seoStepModeBody: "Elige Draft Moderno o Noches de Nostalgia, y ajusta la dificultad. Moderno arranca en Fácil; Nostalgia arranca en Media.",
    seoStepDraftTitle: "2. Abre sobres por rol",
    seoStepDraftBody: "Cada ronda propone cartas para los huecos libres: compara rol, club, temporada, rareza y química antes de elegir.",
    seoStepSeasonTitle: "3. Simula 38 jornadas",
    seoStepSeasonBody: "Cuando completes el XI, el motor convierte calidad, equilibrio y química en un récord de temporada.",
    promptFallback: (club: string, era: string) => `${club}, ${era}: elige una carta que parezca salida de un domingo clásico de Serie A.`,
    comune: "Común",
    rara: "Rara",
    campione: "Campeón",
    icona: "Icono",
    sourced: "Fuente de datos",
    "curated-high": "Perfil histórico",
    "curated-medium": "Perfil curado",
    derived: "Perfil derivado",
    profiloCuratoDefault: "Perfil curado",
    fitPerfect: "Perfecto",
    fitClub: "Mismo club",
    fitEra: "Misma época",
    fitWild: "Comodín",
    fitChemSuffix: "química",
    packProvincia: "Golpe de provincia",
    packIntesa: "Química",
    packAvvioOssatura: "Inicio de bloque histórico",
    packOssatura: "Compañero de temporada",
    packCreatore: "Creador",
    packEquilibrio: "Equilibrio táctico",
    packSacrificio: "Elección de sacrificio",
    packTalentoNascosto: "Talento oculto",
    packStessaEpoca: "Misma época",
    packJollyPazzo: "Comodín loco",
    packExact: "Prompt perfecto",
    packTitolareFisso: "Titular fijo",
    packImpattoGol: "Impacto goleador",
    packRotazione: "Opción de rotación",
    packStoriaClub: "Historia del club",
    packIntesaBandiera: "Química de bandera",
    packIdoloAssoluto: "Ídolo absoluto",
    packEpocaGiusta: "Época correcta",
    packImpatto: "Alto impacto",
    packVersioneCult: "Versión de culto",
    packIcona: "Icono",
    packCultHero: "Héroe de culto",
    packFuoriclasse: "Clase mundial",
    packSorpresa: "Sorpresa",
    packJolly: "Comodín",
    packLeggendaFuori: "Leyenda de provincia",
    risultatoStagione: "Resultado de temporada",
    punti: "puntos",
    valutazione: "Valoración",
    attacco: "Ataque",
    mvp: "MVP",
    cronacaStagione: "Crónica de la temporada",
    copyChallengeLink: "Copiar reto",
    challengeLinkCopied: "Reto copiado",
    sharedChallengeLabel: "Reto para amigos",
    sharedActiveTitle: "Reto de amigos activo",
    sharedActiveTargetTitle: "Equipo a batir",
    sharedActiveTargetSummary: (points: number, rating: number) => `${points} puntos · Valoracion ${rating}`,
    sharedActiveProgress: (picked: number, total: number, progress: number) => `${picked}/${total} elecciones · ${progress}% del XI`,
    sharedComparisonTitle: "Reto contra un equipo compartido",
    yourRunLabel: "Tu partida",
    sharedRunLabel: "Equipo a batir",
    sharedComparisonWon: "Victoria contra el equipo compartido",
    sharedComparisonLost: "Derrota contra el equipo compartido",
    sharedComparisonDraw: "Empate contra el equipo compartido",
    sharedComparisonDetail: (pointsDiff: number, ratingDiff: number) => `${pointsDiff >= 0 ? "+" : ""}${pointsDiff} puntos, ${ratingDiff >= 0 ? "+" : ""}${ratingDiff.toFixed(1)} valoracion.`,
    sharedComparisonTieDetail: "Mismos puntos, valoracion y quimica: reto igualado.",
    recordSimulato: "Récord simulado",
    dettaglioSimulazione: "Detalle de simulación",
    cronacaLabel: "Crónica",
    easterEggNostalgici: "Easter eggs nostálgicos",
    golStats: "goles",
    assistStats: "asist.",
    presStats: "pres.",
    ruoloChiave: "Rol clave",
    gameplayRatingLabel: "Valoración gameplay",
    scegliClubFocus: "Elige el club foco",
    clubFocusKicker: "Club foco",
    modeDraftName: "Draft Moderno",
    modeDraftShort: "Draft",
    modeDraftHardName: "Draft Moderno Difícil",
    modeDraftHardShort: "Difícil",
    modeNostalgiaName: "Noches de Nostalgia",
    modeProvinciaName: "Provincia Mágica",
    modeDraftDesc: "Draft moderno fácil: jugadores post-2010, roles móviles y margen para experimentar.",
    modeDraftHardDesc: "Post-2010 con roles fijos, al menos cuatro clubes y límite de elecciones headline.",
    modeNostalgiaDesc: "Años 70, 80, 90 y pequeños cameos de los 2000: leyendas, scudetti históricos y domingos de VHS.",
    modeProvinciaDesc: "Cagliari, Verona, Parma, Sampdoria, Palermo, Fiorentina, Bologna y otras historias históricas fuera del camino principal.",
    modeDraftTone: "Estrellas recientes, scouting moderno y cruces libres sin bloqueo de club.",
    modeDraftHardTone: "La Serie A reciente en versión expert: equilibrio, trabajo sucio y menos elecciones automáticas.",
    modeNostalgiaShort: "Nostalgia",
    modeNostalgiaTone: "Camisetas amplias, números diez, narraciones eternas y música de tele antigua.",
    modeNostalgiaHardName: "Noches de Nostalgia Difícil",
    modeNostalgiaHardShort: "Nostalgia",
    modeNostalgiaHardDesc: "Archivo histórico con roles fijos, más temporadas obligatorias y casi ningún atajo de los 2000.",
    modeNostalgiaHardTone: "Amarcord en versión dura: menos cameos cómodos y más épocas que encajar.",
    modeProvinciaMediumName: "Provincia Mágica Media",
    modeProvinciaMediumShort: "Provincia",
    modeProvinciaMediumDesc: "Provincia histórica más permisiva: outsiders, héroes de culto y roles móviles para aprender el pool.",
    modeProvinciaMediumTone: "La provincia sigue romántica, pero deja más margen en la primera run.",
    modeProvinciaShort: "Provincia",
    modeProvinciaTone: "Cuando la provincia mete miedo a los gigantes.",
    anni70: "Años 70",
    anni80: "Años 80",
    anni90: "Años 90",
    anni2000: "Años 2000",
    anni2010: "Años 2010",
    moderna: "Era moderna",
    origineDati: "Origen de los datos",
    dataNotice: "Dos historias de draft: Moderno post-2010 y Nostalgia histórica, cada una con dificultades dedicadas. La muestra 2022-23 usa presencias, titularidades y goles de StatBunker; los roles y microcopy siguen siendo metadata de gameplay.",
    cookieBannerLabel: "Preferencias de cookies",
    cookieBannerTitle: "Cookies de analytics",
    cookieBannerBody: "Usamos PostHog para entender qué modos funcionan mejor y mejorar el draft. Puedes rechazarlo en cualquier momento y seguir jugando.",
    cookieAccept: "Aceptar",
    cookieDecline: "Rechazar",
    feedbackOpen: "Feedback",
    feedbackEyebrow: "Nota rápida",
    feedbackTitle: "Ayúdanos a mejorar",
    feedbackClose: "Cerrar feedback",
    feedbackCategoryLabel: "Tipo",
    feedbackCategoryGameplay: "Gameplay",
    feedbackCategoryData: "Jugador o dato",
    feedbackCategoryBug: "Bug",
    feedbackCategoryOther: "Otro",
    feedbackMessageLabel: "Mensaje",
    feedbackMessagePlaceholder: "¿Qué falló, quién falta o qué cambiarías?",
    feedbackEmailLabel: "Email opcional",
    feedbackEmailPlaceholder: "si quieres una respuesta",
    feedbackCancel: "Cancelar",
    feedbackSubmit: "Enviar",
    feedbackSending: "Enviando...",
    feedbackSuccess: "Gracias, feedback recibido.",
    feedbackError: "No pudimos enviarlo. Inténtalo de nuevo en un momento.",
    appSurveyEyebrow: "Encuesta app",
    appSurveyTitle: "¿Quieres Serie A 38-0 como app?",
    appSurveyBody: "Vota la plataforma que usarías. Deja el email solo si quieres novedades.",
    appSurveyPlatformLabel: "Plataforma app",
    appSurveyPlatformIos: "iOS",
    appSurveyPlatformAndroid: "Android",
    appSurveyPlatformBoth: "Ambas",
    appSurveyEmailLabel: "Email opcional",
    appSurveyEmailPlaceholder: "para novedades de la app",
    appSurveySubmit: "Votar",
    appSurveySending: "Enviando...",
    appSurveySentButton: "Voto enviado",
    appSurveySuccess: "Gracias, voto registrado.",
    appSurveyError: "No pudimos registrar el voto. Inténtalo de nuevo en un momento.",
    appSurveyPrivacy: "Sin cuenta: solo un voto de interés y, si lo añades, tu email.",
    gk: "POR",
    lb: "Lateral izq.",
    cb1: "Central",
    cb2: "Central",
    rb: "Lateral der.",
    cm1: "Interior izq.",
    regista: "Regista",
    cm2: "Interior der.",
    trequartista: "Mediapunta",
    lm: "Banda izq.",
    rm: "Banda der.",
    lw: "Extremo izq.",
    st: "Delantero",
    st1: "Punta izq.",
    st2: "Punta der.",
    rw: "Extremo der.",
    gk_abbr: "POR",
    lb_abbr: "LI",
    cb1_abbr: "DFC",
    cb2_abbr: "DFC",
    rb_abbr: "LD",
    cm1_abbr: "MC",
    regista_abbr: "REG",
    cm2_abbr: "MC",
    trequartista_abbr: "MP",
    lm_abbr: "MI",
    rm_abbr: "MD",
    lw_abbr: "EI",
    rw_abbr: "ED",
    st_abbr: "DC",
    st1_abbr: "PUN",
    st2_abbr: "PUN",
    eggviallimancini: "Gemelos del gol",
    eggkvaraosimhen: "Kvaradona + máscara",
    egglookmanosimhen: "Naija Serie A",
    eggleaokaka: "Generación highlights",
    eggbuffonthuram: "Parma copa nostalgia",
    eggadrianokaka: "Brasil en Serie A",
    eggjuliomaicon: "Triplete brasileño",
    eggtotticafu: "Roma scudetto",
    eggmuseo: "Museo del campeonato",
    chronicleTopPlayer: (name: string, rating: number) => `${name} fue el rostro indiscutible de la temporada, liderando al equipo con valoración global ${rating}.`,
    chronicleClubBlock: (club: string, count: number) => `El bloque del club ${club} fue fundamental, con ${count} pilares titulares.`,
    chroniclePhilosophy: (formattedEra: string) => `La filosofía táctica ${formattedEra} dominó la identidad de tu once.`,
    chronicleCountryColony: (country: string, count: number) => `El núcleo de jugadores de ${country} (${count} piezas) creó una química especial en el vestuario.`,
    chronicleMaradona: "En Nápoles basta pronunciar el nombre de Diego para convertir cualquier domingo en poesía futbolera.",
    chronicleRonaldo: "Il Fenomeno Ronaldo abrió los partidos más cerrados con aceleraciones devastadoras, un cheat code de otra época.",
    chronicleAdriano: "La potencia física del Emperador Adriano dobló defensas rivales en el tramo final de la temporada.",
    formatted_anni70: "de los años 70",
    formatted_anni80: "de los años 80",
    formatted_anni90: "de los años 90",
    formatted_anni2000: "de los años 2000",
    formatted_anni2010: "de los años 2010",
    formatted_moderna: "de la era moderna",
    simOut38winsTitle: "38-0: epopeya legendaria",
    simOut38winsDetail: "Has reunido un ejército invencible. Táctica sublime, química vintage y clase absoluta: la historia de la Serie A te pertenece.",
    simOutNoLossesTitle: "Los invencibles",
    simOutNoLossesDetail: "Cero derrotas en 38 jornadas. La Gazzetta dello Sport celebra en portada una defensa de acero y una química digna del gran Milan de Capello.",
    simOutScudettoTitle: "Campeones de Italia",
    simOutScudettoDetail: "Scudetto más que merecido. Una marcha triunfal con destellos de clase pura y una regularidad impresionante durante todo el campeonato.",
    simOutChampionsTitle: "Zona Champions",
    simOutChampionsDetail: "Gran calidad general, pero demasiados empates y algún apagón defensivo te cuestan la pelea por el título. El consuelo llega con la gran Europa.",
  },
  "pt-BR": {
    ...baseTranslations.en,
    heroEyebrow: "Simulador de draft da Serie A",
    heroTitle: "Serie A 38-0",
    heroSubtitle: "Monte o elenco perfeito abrindo pacotes para cada função. Equilibre entrosamento, raridade e cult heroes para completar uma temporada invicta.",
    draftProgress: "Progresso do draft",
    languageSelectLabel: "Idioma",
    seoReadMore: "Ler",
    draftXi: "XI do draft",
    simulated: "Simulado",
    shareCalloutLabel: "Desafio de amigos",
    shareCalloutTitle: "Desafie um amigo depois da simulação",
    shareCalloutBody: "Complete seu XI, copie o link do desafio e comparem campanhas.",
    moduloTattico: "Esquema tático",
    intesa: "Entrosamento",
    laTuaFormazione: "Sua escalação",
    risultati: "Resultados",
    daScegliere: "A escolher",
    scenarioRound: "Cenário de draft · Inspiração da rodada",
    giocatoriLegatiTema: "Jogadores deste clube (+16 entrosamento) ou época (+10 entrosamento) aumentam o entrosamento.",
    giocatoriDisponibili: "Jogadores disponíveis",
    ricominciaDraft: "Reiniciar draft",
    rimescolaPack: "Novo scouting",
    rimescolaPackHint: "Nova rodada de scouting: funções e cartas mudam, mas seu XI continua intacto.",
    packRuoliMisti: "Funções mistas",
    ruoliNelPack: "Funções no pacote",
    slotTarget: "Slot",
    scegliSlotCarta: "Escolha o slot desta carta",
    preparazionePack: "Preparando scouting",
    scoutingInCorso: "Scouting em andamento: estamos preparando as cartas para a formação.",
    scegliModulo: "Escolher formação",
    modeSelectorLabel: "Modos",
    storySelectorLabel: "Histórias",
    difficultySelectorLabel: "Dificuldade",
    lineupPanelLabel: "Escalação",
    draftTabLabel: "Escolhas",
    draftProgressStatus: (progress: number) => `Draft completado em ${progress}%`,
    roundLabel: (round: number) => `Rodada ${round}`,
    signCard: "CONTRATAR",
    draftedPlayersTitle: "Jogadores contratados",
    emptyRosterNote: "Nenhum jogador contratado ainda",
    runIdentityTitle: "Identidade da run",
    seasonMomentsTitle: "Momentos-chave",
    modeDifficultyEasy: "Fácil",
    modeDifficultyMedium: "Média",
    modeDifficultyExpert: "Especialista",
    modeDifficultyHard: "Difícil",
    hiddenCardValueLabel: "Valor da carta oculto",
    hiddenStatValueLabel: "Estatística da carta oculta",
    hiddenSkillsetLabel: "Perfil de scouting oculto",
    hiddenMiniStatsLabel: "Detalhes de scouting ocultos",
    hiddenReasonLabel: "Scouting oculto",
    hiddenLaneLabel: "Faixa oculta",
    hiddenRarityLabel: "Valor oculto",
    hiddenSourceLabel: "Fonte oculta",
    storyModernName: "Moderno",
    storyModernDesc: "Pós-2010",
    storyNostalgiaName: "Nostalgia",
    storyNostalgiaDesc: "Anos 70-2000",
    storyProvinciaName: "Província",
    storyProvinciaDesc: "Outsiders históricos",
    advancedChallengeLabel: "Desafios avançados",
    advancedChallengeEyebrow: "Desafio",
    challengeClassicName: "Clássica",
    challengeClassicDesc: "Draft livre, sem teto de créditos.",
    challengeBudgetName: "Orçamento Mercato",
    challengeBudgetDesc: "Teto de 900 créditos: cada carta tem custo e as estrelas exigem escolhas.",
    challengeTacticalName: "Tático",
    challengeTacticalDesc: "Objetivo ligado à formação: escolha cartas que respeitam o plano tático.",
    budgetStatusLabel: "Orçamento Mercato",
    budgetCredits: "créditos",
    budgetSpentLabel: "Usados",
    cardCostLabel: "Custo",
    tacticalStatusLabel: "Desafio tático",
    tacticalOpenLabel: "A completar",
    tacticalCompleteLabel: "Completo",
    tacticalFitLabel: "Encaixe tático",
    tacticalResultLabel: "Tática",
    tacticalResultComplete: "Cumprida",
    roleMoveLabel: "Mudar função",
    roleMoveAria: (name: string) => `Mudar função de ${name}`,
    roleMovePanelTitle: "Mudar função",
    roleMovePanelBody: "Escolha um espaço livre compatível com as funções desta carta.",
    currentRoleLabel: "Função atual",
    availableRolesLabel: "Funções disponíveis",
    moveToSlot: (slot: string) => `Mover para ${slot}`,
    noRoleMovesAvailable: "Nenhum espaço compatível livre.",
    roleMoveToast: (from: string, to: string) => `Jogador movido de ${from} para ${to}.`,
    closeRoleMovePanel: "Fechar mudança de função",
    fixedRolesLabel: "Funções fixas",
    fixedRolesAria: (name: string) => `Funções fixas para ${name}`,
    seoEyebrow: "Descubra o jogo",
    seoTitle: "Draft da Serie A, entrosamento e simulação em uma única tela jogável",
    seoBody: "Serie A 38-0 é um jogo de navegador estático e imediato: escolha um modo, abra pacotes por função, complete seu XI e veja se ele termina 38 jogos invicto.",
    seoNostalgia: "Notti Nostalgia destaca títulos históricos, camisas 10 e cult heroes dos anos 70 aos 2000.",
    seoDraft: "Draft Moderno abre o grupo pós-2010 com estrelas recentes e cartas contemporâneas além da nostalgia.",
    seoProvincia: "Provincia Magica celebra azarões, clubes provinciais lendários e cartas amadas pelos fãs do calcio.",
    seoInstructionsLabel: "Instruções do Serie A 38-0",
    seoStepModeTitle: "1. Escolha um modo",
    seoStepModeBody: "Escolha Draft Moderno ou Noites de Nostalgia, depois ajuste a dificuldade. Moderno começa em Fácil; Nostalgia começa em Média.",
    seoStepDraftTitle: "2. Abra pacotes por função",
    seoStepDraftBody: "Cada rodada traz cartas para os espaços livres: compare função, clube, temporada, raridade e entrosamento antes de escolher.",
    seoStepSeasonTitle: "3. Simule 38 rodadas",
    seoStepSeasonBody: "Quando o XI estiver completo, o motor transforma qualidade, equilíbrio e entrosamento em campanha.",
    promptFallback: (club: string, era: string) => `${club}, ${era}: escolha uma carta que pareça tirada de um domingo clássico da Serie A.`,
    comune: "Comum",
    rara: "Rara",
    campione: "Campeão",
    icona: "Ícone",
    sourced: "Fonte de dados",
    "curated-high": "Perfil histórico",
    "curated-medium": "Perfil curado",
    derived: "Perfil derivado",
    profiloCuratoDefault: "Perfil curado",
    fitPerfect: "Perfeito",
    fitClub: "Mesmo clube",
    fitEra: "Mesma época",
    fitWild: "Coringa",
    fitChemSuffix: "entrosamento",
    packProvincia: "Achado de província",
    packIntesa: "Entrosamento",
    packAvvioOssatura: "Início de bloco histórico",
    packOssatura: "Companheiro de temporada",
    packCreatore: "Criador",
    packEquilibrio: "Equilíbrio tático",
    packSacrificio: "Escolha de sacrifício",
    packTalentoNascosto: "Talento escondido",
    packStessaEpoca: "Mesma época",
    packJollyPazzo: "Coringa louco",
    packExact: "Prompt perfeito",
    packTitolareFisso: "Titular fixo",
    packImpattoGol: "Impacto em gols",
    packRotazione: "Opção de rotação",
    packStoriaClub: "História do clube",
    packIntesaBandiera: "Entrosamento de ídolo",
    packIdoloAssoluto: "Ídolo absoluto",
    packEpocaGiusta: "Época certa",
    packImpatto: "Alto impacto",
    packVersioneCult: "Versão cult",
    packIcona: "Ícone",
    packCultHero: "Cult hero",
    packFuoriclasse: "Craque mundial",
    packSorpresa: "Surpresa",
    packJolly: "Coringa",
    packLeggendaFuori: "Lenda de província",
    risultatoStagione: "Resultado da temporada",
    punti: "pontos",
    valutazione: "Avaliação",
    attacco: "Ataque",
    mvp: "MVP",
    cronacaStagione: "Crônica da temporada",
    copyChallengeLink: "Copiar desafio",
    challengeLinkCopied: "Desafio copiado",
    sharedChallengeLabel: "Desafio de amigos",
    sharedActiveTitle: "Desafio de amigos ativo",
    sharedActiveTargetTitle: "Time a bater",
    sharedActiveTargetSummary: (points: number, rating: number) => `${points} pontos · Avaliacao ${rating}`,
    sharedActiveProgress: (picked: number, total: number, progress: number) => `${picked}/${total} escolhas · ${progress}% do XI`,
    sharedComparisonTitle: "Desafio contra um time compartilhado",
    yourRunLabel: "Sua campanha",
    sharedRunLabel: "Time a bater",
    sharedComparisonWon: "Vitoria contra o time compartilhado",
    sharedComparisonLost: "Derrota contra o time compartilhado",
    sharedComparisonDraw: "Empate contra o time compartilhado",
    sharedComparisonDetail: (pointsDiff: number, ratingDiff: number) => `${pointsDiff >= 0 ? "+" : ""}${pointsDiff} pontos, ${ratingDiff >= 0 ? "+" : ""}${ratingDiff.toFixed(1)} avaliacao.`,
    sharedComparisonTieDetail: "Mesmos pontos, avaliacao e entrosamento: desafio empatado.",
    recordSimulato: "Recorde simulado",
    dettaglioSimulazione: "Detalhe da simulação",
    cronacaLabel: "Crônica",
    easterEggNostalgici: "Easter eggs nostálgicos",
    golStats: "gols",
    assistStats: "assist.",
    presStats: "jogos",
    ruoloChiave: "Função-chave",
    gameplayRatingLabel: "Avaliação gameplay",
    scegliClubFocus: "Escolha o clube foco",
    clubFocusKicker: "Clube foco",
    modeDraftName: "Draft Moderno",
    modeDraftShort: "Draft",
    modeDraftHardName: "Draft Moderno Difícil",
    modeDraftHardShort: "Difícil",
    modeNostalgiaName: "Noites de Nostalgia",
    modeProvinciaName: "Província Mágica",
    modeDraftDesc: "Draft moderno fácil: jogadores pós-2010, funções móveis e espaço para experimentar.",
    modeDraftHardDesc: "Pós-2010 com funções fixas, pelo menos quatro clubes e limite para escolhas headline.",
    modeNostalgiaDesc: "Anos 70, 80, 90 e pequenos cameos dos 2000: lendas, scudetti históricos e domingos em VHS.",
    modeProvinciaDesc: "Cagliari, Verona, Parma, Sampdoria, Palermo, Fiorentina, Bologna e outras histórias históricas fora do eixo principal.",
    modeDraftTone: "Estrelas recentes, scouting moderno e combinações livres sem trava de clube.",
    modeDraftHardTone: "A Serie A recente em versão expert: equilíbrio, trabalho sujo e menos escolhas automáticas.",
    modeNostalgiaShort: "Nostalgia",
    modeNostalgiaTone: "Camisas largas, camisas 10, narrações infinitas e trilhas de TV antiga.",
    modeNostalgiaHardName: "Noites de Nostalgia Difícil",
    modeNostalgiaHardShort: "Nostalgia",
    modeNostalgiaHardDesc: "Arquivo histórico com funções fixas, mais temporadas obrigatórias e quase nenhum atalho dos anos 2000.",
    modeNostalgiaHardTone: "Amarcord em versão dura: menos cameos confortáveis e mais épocas para encaixar.",
    modeProvinciaMediumName: "Província Mágica Média",
    modeProvinciaMediumShort: "Província",
    modeProvinciaMediumDesc: "Província histórica mais permissiva: outsiders, cult heroes e funções móveis para aprender o pool.",
    modeProvinciaMediumTone: "A província continua romântica, mas dá mais margem na primeira run.",
    modeProvinciaShort: "Província",
    modeProvinciaTone: "Quando a província assusta os gigantes.",
    anni70: "Anos 70",
    anni80: "Anos 80",
    anni90: "Anos 90",
    anni2000: "Anos 2000",
    anni2010: "Anos 2010",
    moderna: "Era moderna",
    origineDati: "Origem dos dados",
    dataNotice: "Duas histórias de draft: Moderno pós-2010 e Nostalgia histórica, cada uma com dificuldades dedicadas. O recorte 2022-23 usa presenças, titularidades e gols da StatBunker; funções e microcopy seguem como metadados de gameplay.",
    cookieBannerLabel: "Preferências de cookies",
    cookieBannerTitle: "Cookies de analytics",
    cookieBannerBody: "Usamos PostHog para entender quais modos funcionam melhor e melhorar o draft. Você pode recusar a qualquer momento e continuar jogando.",
    cookieAccept: "Aceitar",
    cookieDecline: "Recusar",
    feedbackOpen: "Feedback",
    feedbackEyebrow: "Nota rápida",
    feedbackTitle: "Ajude a melhorar",
    feedbackClose: "Fechar feedback",
    feedbackCategoryLabel: "Tipo",
    feedbackCategoryGameplay: "Gameplay",
    feedbackCategoryData: "Jogador ou dado",
    feedbackCategoryBug: "Bug",
    feedbackCategoryOther: "Outro",
    feedbackMessageLabel: "Mensagem",
    feedbackMessagePlaceholder: "O que pareceu errado, quem está faltando ou o que você mudaria?",
    feedbackEmailLabel: "Email opcional",
    feedbackEmailPlaceholder: "se quiser uma resposta",
    feedbackCancel: "Cancelar",
    feedbackSubmit: "Enviar",
    feedbackSending: "Enviando...",
    feedbackSuccess: "Obrigado, feedback recebido.",
    feedbackError: "Não conseguimos enviar. Tente de novo em instantes.",
    appSurveyEyebrow: "Pesquisa do app",
    appSurveyTitle: "Você quer o Serie A 38-0 como app?",
    appSurveyBody: "Vote na plataforma que usaria. Deixe o email só se quiser novidades.",
    appSurveyPlatformLabel: "Plataforma do app",
    appSurveyPlatformIos: "iOS",
    appSurveyPlatformAndroid: "Android",
    appSurveyPlatformBoth: "Ambas",
    appSurveyEmailLabel: "Email opcional",
    appSurveyEmailPlaceholder: "para novidades do app",
    appSurveySubmit: "Votar",
    appSurveySending: "Enviando...",
    appSurveySentButton: "Voto enviado",
    appSurveySuccess: "Obrigado, voto registrado.",
    appSurveyError: "Não conseguimos registrar o voto. Tente de novo em instantes.",
    appSurveyPrivacy: "Sem conta: só um voto de interesse e, se você quiser, seu email.",
    gk: "GOL",
    lb: "Lat. esq.",
    cb1: "Zagueiro",
    cb2: "Zagueiro",
    rb: "Lat. dir.",
    cm1: "Meia esq.",
    regista: "Regista",
    cm2: "Meia dir.",
    trequartista: "Meia central",
    lm: "Ala esq.",
    rm: "Ala dir.",
    lw: "Ponta esq.",
    st: "Centroavante",
    st1: "Ponta esq.",
    st2: "Ponta dir.",
    rw: "Ponta dir.",
    gk_abbr: "GOL",
    lb_abbr: "LE",
    cb1_abbr: "ZAG",
    cb2_abbr: "ZAG",
    rb_abbr: "LD",
    cm1_abbr: "MC",
    regista_abbr: "REG",
    cm2_abbr: "MC",
    trequartista_abbr: "MEI",
    lm_abbr: "AE",
    rm_abbr: "AD",
    lw_abbr: "PE",
    rw_abbr: "PD",
    st_abbr: "CA",
    st1_abbr: "ATA",
    st2_abbr: "ATA",
    eggviallimancini: "Gêmeos do gol",
    eggkvaraosimhen: "Kvaradona + máscara",
    egglookmanosimhen: "Naija Serie A",
    eggleaokaka: "Geração highlights",
    eggbuffonthuram: "Parma copa nostalgia",
    eggadrianokaka: "Brasil na Serie A",
    eggjuliomaicon: "Triplete brasileiro",
    eggtotticafu: "Roma scudetto",
    eggmuseo: "Museu do campeonato",
    chronicleTopPlayer: (name: string, rating: number) => `${name} foi o rosto indiscutível da temporada, carregando o time com avaliação geral ${rating}.`,
    chronicleClubBlock: (club: string, count: number) => `O bloco do clube ${club} foi fundamental, com ${count} pilares titulares.`,
    chroniclePhilosophy: (formattedEra: string) => `A filosofia tática ${formattedEra} dominou a identidade do seu onze.`,
    chronicleCountryColony: (country: string, count: number) => `O núcleo de jogadores de ${country} (${count} peças) criou um entrosamento especial no vestiário.`,
    chronicleMaradona: "Em Nápoles, basta dizer Diego para transformar qualquer domingo em poesia de futebol.",
    chronicleRonaldo: "Il Fenomeno Ronaldo abriu os jogos mais fechados com arrancadas devastadoras, um cheat code de outra época.",
    chronicleAdriano: "A força física do Imperador Adriano dobrou defesas adversárias no fim da temporada.",
    formatted_anni70: "dos anos 70",
    formatted_anni80: "dos anos 80",
    formatted_anni90: "dos anos 90",
    formatted_anni2000: "dos anos 2000",
    formatted_anni2010: "dos anos 2010",
    formatted_moderna: "da era moderna",
    simOut38winsTitle: "38-0: epopeia lendária",
    simOut38winsDetail: "Você montou um exército invencível. Tática sublime, entrosamento vintage e classe absoluta: a história da Serie A é sua.",
    simOutNoLossesTitle: "Os invencíveis",
    simOutNoLossesDetail: "Zero derrotas em 38 rodadas. A Gazzetta dello Sport celebra na capa uma defesa de aço e entrosamento digno do grande Milan de Capello.",
    simOutScudettoTitle: "Campeões da Itália",
    simOutScudettoDetail: "Scudetto mais que merecido. Uma marcha triunfal com lampejos de classe pura e regularidade impressionante durante todo o campeonato.",
    simOutChampionsTitle: "Zona Champions",
    simOutChampionsDetail: "Grande qualidade geral, mas empates demais e alguns apagões defensivos custam a briga pelo título. O consolo vem com a grande Europa.",
  },
  fr: {
    ...baseTranslations.en,
    heroEyebrow: "Simulateur de draft Serie A",
    heroTitle: "Serie A 38-0",
    heroSubtitle: "Construis l'effectif parfait en ouvrant des packs pour chaque rôle. Équilibre entente, rareté et héros cultes pour finir une saison invaincue.",
    draftProgress: "Progression du draft",
    languageSelectLabel: "Langue",
    seoReadMore: "Lire",
    draftXi: "XI du draft",
    simulated: "Simulé",
    shareCalloutLabel: "Défi entre amis",
    shareCalloutTitle: "Défie un ami après la simulation",
    shareCalloutBody: "Complète ton XI, copie le lien du défi et comparez vos bilans.",
    moduloTattico: "Schéma tactique",
    intesa: "Entente",
    laTuaFormazione: "Ta composition",
    risultati: "Résultats",
    daScegliere: "À choisir",
    scenarioRound: "Scénario de draft · Inspiration du tour",
    giocatoriLegatiTema: "Les joueurs de ce club (+16 entente) ou de cette époque (+10 entente) renforcent l'entente.",
    giocatoriDisponibili: "Joueurs disponibles",
    ricominciaDraft: "Recommencer le draft",
    rimescolaPack: "Nouveau scouting",
    rimescolaPackHint: "Nouveau tour de scouting : les rôles et les cartes changent, ton XI reste intact.",
    packRuoliMisti: "Rôles mixtes",
    ruoliNelPack: "Rôles du pack",
    slotTarget: "Poste",
    scegliSlotCarta: "Choisis le poste de cette carte",
    preparazionePack: "Préparation du scouting",
    scoutingInCorso: "Scouting en cours : préparation des cartes pour le schéma.",
    scegliModulo: "Choisir la formation",
    modeSelectorLabel: "Modes",
    storySelectorLabel: "Histoires",
    difficultySelectorLabel: "Difficulté",
    lineupPanelLabel: "Composition",
    draftTabLabel: "Choix",
    draftProgressStatus: (progress: number) => `Draft complété à ${progress}%`,
    roundLabel: (round: number) => `Tour ${round}`,
    signCard: "SIGNER",
    draftedPlayersTitle: "Joueurs recrutés",
    emptyRosterNote: "Aucun joueur recruté pour l'instant",
    runIdentityTitle: "Identité de la run",
    seasonMomentsTitle: "Moments clés",
    modeDifficultyEasy: "Facile",
    modeDifficultyMedium: "Moyenne",
    modeDifficultyExpert: "Experte",
    modeDifficultyHard: "Difficile",
    hiddenCardValueLabel: "Valeur de carte masquée",
    hiddenStatValueLabel: "Stat de carte masquée",
    hiddenSkillsetLabel: "Profil scouting masqué",
    hiddenMiniStatsLabel: "Détails scouting masqués",
    hiddenReasonLabel: "Scouting masqué",
    hiddenLaneLabel: "Piste masquée",
    hiddenRarityLabel: "Valeur masquée",
    hiddenSourceLabel: "Source masquée",
    storyModernName: "Moderne",
    storyModernDesc: "Post-2010",
    storyNostalgiaName: "Nostalgie",
    storyNostalgiaDesc: "Années 70-2000",
    storyProvinciaName: "Province",
    storyProvinciaDesc: "Outsiders historiques",
    advancedChallengeLabel: "Défis avancés",
    advancedChallengeEyebrow: "Défi",
    challengeClassicName: "Classique",
    challengeClassicDesc: "Draft libre, sans plafond de crédits.",
    challengeBudgetName: "Budget Mercato",
    challengeBudgetDesc: "Plafond de 900 crédits : chaque carte coûte, les stars imposent des choix.",
    challengeTacticalName: "Tactique",
    challengeTacticalDesc: "Objectif lié au schéma : choisis des cartes qui respectent le plan tactique.",
    budgetStatusLabel: "Budget Mercato",
    budgetCredits: "crédits",
    budgetSpentLabel: "Utilisés",
    cardCostLabel: "Coût",
    tacticalStatusLabel: "Défi tactique",
    tacticalOpenLabel: "À compléter",
    tacticalCompleteLabel: "Complété",
    tacticalFitLabel: "Compatibilité tactique",
    tacticalResultLabel: "Tactique",
    tacticalResultComplete: "Réussi",
    roleMoveLabel: "Changer de rôle",
    roleMoveAria: (name: string) => `Changer le rôle de ${name}`,
    roleMovePanelTitle: "Changer de rôle",
    roleMovePanelBody: "Choisis un poste libre compatible avec les rôles de cette carte.",
    currentRoleLabel: "Rôle actuel",
    availableRolesLabel: "Rôles disponibles",
    moveToSlot: (slot: string) => `Déplacer en ${slot}`,
    noRoleMovesAvailable: "Aucun poste compatible libre.",
    roleMoveToast: (from: string, to: string) => `Joueur déplacé de ${from} à ${to}.`,
    closeRoleMovePanel: "Fermer le changement de rôle",
    fixedRolesLabel: "Rôles fixes",
    fixedRolesAria: (name: string) => `Rôles fixes pour ${name}`,
    seoEyebrow: "Découvrir le jeu",
    seoTitle: "Draft de Serie A, entente et simulation sur un seul écran jouable",
    seoBody: "Serie A 38-0 est un jeu de navigateur statique et immédiat : choisis un mode, ouvre des packs par rôle, complète ton XI et vois s'il peut finir 38 matchs invaincu.",
    seoNostalgia: "Notti Nostalgia met en avant les titres historiques, les numéros dix et les cult heroes des années 70 aux années 2000.",
    seoDraft: "Draft Moderno ouvre le vivier post-2010 avec des stars récentes et des cartes contemporaines au-delà de la nostalgie.",
    seoProvincia: "Provincia Magica célèbre les outsiders, les clubs provinciaux légendaires et les cartes aimées par les fans du calcio.",
    seoInstructionsLabel: "Instructions Serie A 38-0",
    seoStepModeTitle: "1. Choisis un mode",
    seoStepModeBody: "Choisis Draft Moderne ou Nuits Nostalgie, puis règle la difficulté. Moderne démarre en Facile; Nostalgie démarre en Moyenne.",
    seoStepDraftTitle: "2. Ouvre des packs par rôle",
    seoStepDraftBody: "Chaque tour propose des cartes pour les postes libres : compare rôle, club, saison, rareté et entente avant de choisir.",
    seoStepSeasonTitle: "3. Simule 38 journées",
    seoStepSeasonBody: "Une fois le XI complet, le moteur transforme qualité, équilibre et entente en bilan de saison.",
    promptFallback: (club: string, era: string) => `${club}, ${era} : choisis une carte sortie d'un dimanche classique de Serie A.`,
    comune: "Commune",
    rara: "Rare",
    campione: "Champion",
    icona: "Icône",
    sourced: "Source de données",
    "curated-high": "Profil historique",
    "curated-medium": "Profil sélectionné",
    derived: "Profil dérivé",
    profiloCuratoDefault: "Profil sélectionné",
    fitPerfect: "Parfait",
    fitClub: "Même club",
    fitEra: "Même époque",
    fitWild: "Joker",
    fitChemSuffix: "entente",
    packProvincia: "Coup de province",
    packIntesa: "Entente",
    packAvvioOssatura: "Début de bloc historique",
    packOssatura: "Coéquipier de saison",
    packCreatore: "Créateur",
    packEquilibrio: "Équilibre tactique",
    packSacrificio: "Choix de sacrifice",
    packTalentoNascosto: "Talent caché",
    packStessaEpoca: "Même époque",
    packJollyPazzo: "Joker fou",
    packExact: "Prompt parfait",
    packTitolareFisso: "Titulaire régulier",
    packImpattoGol: "Impact but",
    packRotazione: "Option de rotation",
    packStoriaClub: "Histoire du club",
    packIntesaBandiera: "Entente d'icône",
    packIdoloAssoluto: "Idole absolue",
    packEpocaGiusta: "Bonne époque",
    packImpatto: "Fort impact",
    packVersioneCult: "Version culte",
    packIcona: "Icône",
    packCultHero: "Héros culte",
    packFuoriclasse: "Classe mondiale",
    packSorpresa: "Surprise",
    packJolly: "Joker",
    packLeggendaFuori: "Légende de province",
    risultatoStagione: "Résultat de saison",
    punti: "points",
    valutazione: "Note",
    attacco: "Attaque",
    mvp: "MVP",
    cronacaStagione: "Chronique de la saison",
    copyChallengeLink: "Copier le défi",
    challengeLinkCopied: "Défi copié",
    sharedChallengeLabel: "Défi entre amis",
    sharedActiveTitle: "Défi entre amis actif",
    sharedActiveTargetTitle: "Equipe a battre",
    sharedActiveTargetSummary: (points: number, rating: number) => `${points} points · Note ${rating}`,
    sharedActiveProgress: (picked: number, total: number, progress: number) => `${picked}/${total} choix · ${progress}% du XI`,
    sharedComparisonTitle: "Défi contre une equipe partagee",
    yourRunLabel: "Ta run",
    sharedRunLabel: "Equipe a battre",
    sharedComparisonWon: "Victoire contre l'equipe partagee",
    sharedComparisonLost: "Defaite contre l'equipe partagee",
    sharedComparisonDraw: "Match nul contre l'equipe partagee",
    sharedComparisonDetail: (pointsDiff: number, ratingDiff: number) => `${pointsDiff >= 0 ? "+" : ""}${pointsDiff} points, ${ratingDiff >= 0 ? "+" : ""}${ratingDiff.toFixed(1)} note.`,
    sharedComparisonTieDetail: "Memes points, note et collectif: le defi est parfaitement egal.",
    recordSimulato: "Bilan simulé",
    dettaglioSimulazione: "Détail de simulation",
    cronacaLabel: "Chronique",
    easterEggNostalgici: "Easter eggs nostalgiques",
    golStats: "buts",
    assistStats: "passes",
    presStats: "app.",
    ruoloChiave: "Rôle clé",
    gameplayRatingLabel: "Note gameplay",
    scegliClubFocus: "Choisis le club focus",
    clubFocusKicker: "Club focus",
    modeDraftName: "Draft Moderne",
    modeDraftShort: "Draft",
    modeDraftHardName: "Draft Moderne Difficile",
    modeDraftHardShort: "Difficile",
    modeNostalgiaName: "Nuits Nostalgie",
    modeProvinciaName: "Province Magique",
    modeDraftDesc: "Draft moderne facile : joueurs post-2010, rôles mobiles et place pour expérimenter.",
    modeDraftHardDesc: "Post-2010 avec rôles fixes, au moins quatre clubs et plafond sur les choix headline.",
    modeNostalgiaDesc: "Années 70, 80, 90 et petits caméos des années 2000 : légendes, scudetti historiques et dimanches en VHS.",
    modeProvinciaDesc: "Cagliari, Vérone, Parme, Sampdoria, Palermo, Fiorentina, Bologna et autres histoires historiques hors des sentiers battus.",
    modeDraftTone: "Stars récentes, scouting moderne et croisements libres sans verrou de club.",
    modeDraftHardTone: "La Serie A récente en version experte : équilibre, travail de l'ombre et moins de choix automatiques.",
    modeNostalgiaShort: "Nostalgie",
    modeNostalgiaTone: "Maillots larges, numéros dix, commentaires interminables et génériques de vieille télé.",
    modeNostalgiaHardName: "Nuits Nostalgie Difficile",
    modeNostalgiaHardShort: "Nostalgie",
    modeNostalgiaHardDesc: "Archive historique avec rôles fixes, plus de saisons obligatoires et presque aucun raccourci années 2000.",
    modeNostalgiaHardTone: "Souvenir en version dure : moins de caméos faciles, plus d'époques à assembler.",
    modeProvinciaMediumName: "Province Magique Moyenne",
    modeProvinciaMediumShort: "Province",
    modeProvinciaMediumDesc: "Province historique plus permissive : outsiders, héros cultes et rôles mobiles pour apprendre le pool.",
    modeProvinciaMediumTone: "La province reste romantique, avec plus de marge sur la première run.",
    modeProvinciaShort: "Province",
    modeProvinciaTone: "Quand la province fait trembler les géants.",
    anni70: "Années 70",
    anni80: "Années 80",
    anni90: "Années 90",
    anni2000: "Années 2000",
    anni2010: "Années 2010",
    moderna: "Ère moderne",
    origineDati: "Origine des données",
    dataNotice: "Deux histoires de draft : Moderne post-2010 et Nostalgie historique, chacune avec ses difficultés dédiées. L'extrait 2022-23 utilise apparitions, titularisations et buts de StatBunker; les rôles et microcopies restent des métadonnées de gameplay.",
    cookieBannerLabel: "Préférences cookies",
    cookieBannerTitle: "Cookies analytics",
    cookieBannerBody: "Nous utilisons PostHog pour comprendre quels modes fonctionnent le mieux et améliorer le draft. Tu peux refuser à tout moment et continuer à jouer.",
    cookieAccept: "Accepter",
    cookieDecline: "Refuser",
    feedbackOpen: "Feedback",
    feedbackEyebrow: "Note rapide",
    feedbackTitle: "Aide-nous à améliorer le jeu",
    feedbackClose: "Fermer le feedback",
    feedbackCategoryLabel: "Type",
    feedbackCategoryGameplay: "Gameplay",
    feedbackCategoryData: "Joueur ou donnée",
    feedbackCategoryBug: "Bug",
    feedbackCategoryOther: "Autre",
    feedbackMessageLabel: "Message",
    feedbackMessagePlaceholder: "Qu'est-ce qui cloche, qui manque, ou que changerais-tu ?",
    feedbackEmailLabel: "Email facultatif",
    feedbackEmailPlaceholder: "si tu veux une réponse",
    feedbackCancel: "Annuler",
    feedbackSubmit: "Envoyer",
    feedbackSending: "Envoi...",
    feedbackSuccess: "Merci, feedback reçu.",
    feedbackError: "Impossible d'envoyer. Réessaie dans un instant.",
    appSurveyEyebrow: "Sondage app",
    appSurveyTitle: "Tu voudrais Serie A 38-0 en app ?",
    appSurveyBody: "Vote pour la plateforme que tu utiliserais. Laisse ton email seulement si tu veux des nouvelles.",
    appSurveyPlatformLabel: "Plateforme app",
    appSurveyPlatformIos: "iOS",
    appSurveyPlatformAndroid: "Android",
    appSurveyPlatformBoth: "Les deux",
    appSurveyEmailLabel: "Email optionnel",
    appSurveyEmailPlaceholder: "pour les nouvelles de l'app",
    appSurveySubmit: "Voter",
    appSurveySending: "Envoi...",
    appSurveySentButton: "Vote envoyé",
    appSurveySuccess: "Merci, vote enregistré.",
    appSurveyError: "Impossible d'enregistrer le vote. Réessaie dans un instant.",
    appSurveyPrivacy: "Pas de compte : seulement un vote d'intérêt et, si tu l'ajoutes, ton email.",
    gk: "GB",
    lb: "Latéral g.",
    cb1: "Déf. central",
    cb2: "Déf. central",
    rb: "Latéral d.",
    cm1: "Milieu g.",
    regista: "Regista",
    cm2: "Milieu d.",
    trequartista: "Meneur",
    lm: "Couloir g.",
    rm: "Couloir d.",
    lw: "Ailier g.",
    st: "Avant-centre",
    st1: "Att. g.",
    st2: "Att. d.",
    rw: "Ailier d.",
    gk_abbr: "GB",
    lb_abbr: "LG",
    cb1_abbr: "DC",
    cb2_abbr: "DC",
    rb_abbr: "LD",
    cm1_abbr: "MC",
    regista_abbr: "REG",
    cm2_abbr: "MC",
    trequartista_abbr: "MOC",
    lm_abbr: "MG",
    rm_abbr: "MD",
    lw_abbr: "AG",
    rw_abbr: "AD",
    st_abbr: "BU",
    st1_abbr: "ATT",
    st2_abbr: "ATT",
    eggviallimancini: "Jumeaux du but",
    eggkvaraosimhen: "Kvaradona + masque",
    egglookmanosimhen: "Naija Serie A",
    eggleaokaka: "Génération highlights",
    eggbuffonthuram: "Parma coupe nostalgie",
    eggadrianokaka: "Brésil en Serie A",
    eggjuliomaicon: "Triplé brésilien",
    eggtotticafu: "Roma scudetto",
    eggmuseo: "Musée du championnat",
    chronicleTopPlayer: (name: string, rating: number) => `${name} a été le visage incontestable de la saison, portant l'équipe avec une note globale de ${rating}.`,
    chronicleClubBlock: (club: string, count: number) => `Le bloc du club ${club} a été fondamental, avec ${count} piliers titulaires.`,
    chroniclePhilosophy: (formattedEra: string) => `La philosophie tactique ${formattedEra} a dominé l'identité de ton onze.`,
    chronicleCountryColony: (country: string, count: number) => `Le noyau de joueurs venus de ${country} (${count} éléments) a créé une entente spéciale dans le vestiaire.`,
    chronicleMaradona: "À Naples, il suffit de prononcer Diego pour transformer n'importe quel dimanche en poésie footballistique.",
    chronicleRonaldo: "Il Fenomeno Ronaldo a ouvert les matchs les plus fermés avec des accélérations dévastatrices, un cheat code d'une autre époque.",
    chronicleAdriano: "La puissance physique de l'Empereur Adriano a plié les défenses adverses en fin de saison.",
    formatted_anni70: "des années 70",
    formatted_anni80: "des années 80",
    formatted_anni90: "des années 90",
    formatted_anni2000: "des années 2000",
    formatted_anni2010: "des années 2010",
    formatted_moderna: "de l'ère moderne",
    simOut38winsTitle: "38-0 : épopée légendaire",
    simOut38winsDetail: "Tu as assemblé une armée invincible. Tactique sublime, entente vintage et classe absolue : l'histoire de la Serie A t'appartient.",
    simOutNoLossesTitle: "Les invincibles",
    simOutNoLossesDetail: "Zéro défaite en 38 journées. La Gazzetta dello Sport célèbre en une une défense d'acier et une entente digne du grand Milan de Capello.",
    simOutScudettoTitle: "Champions d'Italie",
    simOutScudettoDetail: "Scudetto largement mérité. Une marche triomphale portée par des éclairs de classe pure et une régularité impressionnante sur toute la saison.",
    simOutChampionsTitle: "Zone Champions",
    simOutChampionsDetail: "Grande qualité globale, mais trop de nuls et quelques trous d'air défensifs coûtent la course au titre. Consolation avec la grande Europe.",
  },
};
